module.exports = __webpack_public_path__ + "static/media/node-js.18132237.png";